<div class="dialog-wrapper">
  <div class="c-dialog-content">
    <div class="success-error-wrapper">
      <img class="centered success-error-image mb-24-px" src="./../../../../assets/images/dialogs/success/return.svg"
        alt="return-success">
      <h3 class="centered success-error-heading mb-16-px">Return initiated</h3>
      <p class="centered success success-error-paragraph mb-20-px">
        Your request will be processed in 1-2 business days. Fastparts will notify you via phone and email about the
        status.
      </p>
      <a (click)="closeDialog()" class="centered link">Close</a>

    </div>
  </div>
</div>
